import { data } from "jquery";
import moment from 'moment-timezone'
import { Popup } from '@bryntum/scheduler'

export default function getDataConfig(response, Scheduler, vm, DomClassList, panelFilterObj) {
    const apiUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : "")
    var imageClassName = '';
    var isZoomChanged = false;
    var isUnassignedResCountAvailable = 0;
    // var resAvailbleList = [];
    const schedulerConfig = new Scheduler({
        //autoHeight: true,
        summaryRenderValue: "soldunits",
        // height : "88vh",
        cls: 'b-schedulercalendar',
        appendTo: "container",
        response: response,
        startDate: new Date(vm.visibleStartDate), //July 5th
        //endDate : new Date(moment(vm.filterObj.endDate).subtract('15', 'days').format("YYYY-MM-DD")), //jan 7th
        barMargin: 15,
        resourceImagePath: "https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?cs=srgb&dl=pexels-binyamin-mellish-106399.jpg&fm=jpg",
        infiniteScroll: true,
        direction: 'horizontal',
        rowHeight:  55,
        tickSize: 70,
        snap: true,
        // use below crudManager to change default event to custom event name when "eventDragCreate"
        // crudManager : {
        //     autoLoad   : true,
        //     eventStore : {
        //         fields : [
        //             { name : 'name',  defaultValue : "Custom Event Name" }
        //         ]
        //     },
        // },
        // resourceImagePath : 'resources/',
        // useInitialAnimation : 'slide-from-top',
        timeResolution: {
            unit: 'day',
            increment: 1
        },
        scrollManager: {
            startScrollDelay: 0,
            // direction: 'horizontal',
            scrollSpeed: 1,
            stopScrollWhenPointerOut: false
        },
        viewPreset: {
            id: 'myPreset',
            name: 'My view preset',
            base: 'hourAndDay',
            tickWidth: 100,
            tickHeight: 200,
            headers: [
                {
                    unit: 'month',
                    dateFormat: 'MMMM YYYY',
                    align: 'start'
                },
                {
                    unit: 'day',
                    // dateFormat : 'DD<br>ddd'
                    renderer: function (start, end, headerConfig, index) {
                        var date = moment(start).format("DD")
                        var day = moment(start).format("ddd")
                        //console.log("DATE FORMAT RENDERER -->", "START",start, "END",end,"HEADER CONFIG",headerConfig, "INDEX",index)
                        return '<span class="custom-header-row"><span class="header-date">' + date + '</span><span class="header-day">' + day + '</span></span>';
                    },
                    align: 'center'
                },
                // {
                //     unit : 'day',
                //     dateFormat : 'ddd',
                // }
            ],
        },
        visibleDate: {
            // Visible date is to view the start date position - (start/end/center/nearest) 
            // Required only when infinte scroll is true
            date: new Date(vm.visibleStartDate),
            block: 'start'
        },
        allowOverlap: true,
        zoomOnTimeAxisDoubleClick: false,
        zoomOnMouseWheel: false,
        createEventOnDblClick: false,
        resourceMargin: 11, // top and bottom space of reservation/event.
        ignoreDomEventsWhileScrolling: true,
        features: {
            group: {
                field: 'UnitTypeId',  // grouping by unitTypeId
                // field: 'UnitTypeName', // grouping by unitTypeName
                disabled: vm.clientType[0].IsHostMode == 1 ? true : false,
                groupSortFn: (a, b) => 1,
                toggleOnRowClick: true,
                renderer: function (groupColumn) {
                    if (groupColumn.column.isResourceCollapseColumn) {
                        // return '<span class="custom-grouping-row"><span class="groupByHeader">' + groupColumn.groupRowFor + '  ' +'('+(groupColumn.count)+')' +'</span></span>';
                        if (groupColumn.column.isResourceCollapseColumn) {
                            const assignedRecords = groupColumn.groupRecords.filter(record => record.IsAssigned === 1);
                            const assignedCount = assignedRecords.length;
                            if (assignedCount > 0) {
                                // Showing count only for records where IsAssigned is 1
                                // return '<span class="custom-grouping-row"><span class="groupByHeader">' + groupColumn.groupRowFor + '  ' + '(' + assignedCount + ')' + '</span></span>';

                                // fetching unique unit type names
                                let uniqueUnitTypeNames = [...new Set(groupColumn.groupRecords.map(record => record.data.UnitTypeName))].join(', ');
                                return '<span class="custom-grouping-row"><span class="groupByHeader">' + uniqueUnitTypeNames + '  ' + '(' + assignedCount + ')' + '</span></span>';
                            }
                        }
                        
                    } else {
                        return '';
                    }
                }, 
            },
            //expandOnCellClick: true,
            eventTooltip: false,
            eventDragCreate: {
                disabled: false, // make false to click and drag on empty area in the schedule to create an event
                showTooltip: false
            },
            eventEdit: true, // not editable after creating new event
            eventDrag: false, // enable true to drag and dop the events
            eventMenu: false, // triggers on right click of the event
            scheduleMenu: false, //disbaled menu on right click for each cell
            timeAxisHeaderMenu: false,  //disbaled menu on right click for dates/days
            timeRanges: {
                enableResizing: true,
                showCurrentTimeLine: true,
                showHeaderElements: true,
            },
            resourceTimeRanges: {
                enableMouseEvents: true
            },
            summary: {
                // refresh/reload the data in summary row
                renderer: ({ startDate: startDate }) => {
                    // console.log("summary", moment(startDate).format("YYYY-MM-DD"))
                    var dateObj = vm.schedulerConfig.response.dateSummary.filter(function (date) {
                        if (date.StartDate == moment(startDate).format("YYYY-MM-DD")) {
                            return date;
                        }
                    });
                    if (dateObj[0] == undefined) { return }

                    if (vm.schedulerConfig.summaryRenderValue === 'soldunits') {
                        $(".btn-soldunits").addClass("btn-summary active");
                        return dateObj[0].SoldUnitsCount ? dateObj[0].SoldUnitsCount : '0';
                    } else if (vm.schedulerConfig.summaryRenderValue === 'availableunits') {
                        $(".btn-availableunits").addClass("btn-summary active");
                        return dateObj[0].AvailUnitsCount ? dateObj[0].AvailUnitsCount : '0';
                    } else if (vm.schedulerConfig.summaryRenderValue === 'occupancy') {
                        $(".btn-occupancy").addClass("btn-summary active");
                        return dateObj[0].AvailUnitsPercent ? dateObj[0].AvailUnitsPercent : '0';
                    }
                },
            },
            groupSummary : {
                target : 'header',
                collapseToHeader : false,    
                //    renderer: ({ startDate: startDate, endDate, eventStore, resourceStore, events, resources, groupRecord, groupField, groupValue }) => {
                //     var filteredGroupSummary = vm.schedulerConfig.response.groupSummaryResponse.filter(function (date) {
                //             if (date.group_startDate == moment(startDate).format("YYYY-MM-DD") && date.group_unitTypeName === groupValue) {
                //                 return date;
                //             }
                //         });
                //         if (!filteredGroupSummary || filteredGroupSummary.length === 0) {
                //             return;
                //         }
                //         if (vm.schedulerConfig.summaryRenderValue === 'soldunits') {
                //             return filteredGroupSummary[0].group_soldUnitsCount ? filteredGroupSummary[0].group_soldUnitsCount : '0';
                //         } else if (vm.schedulerConfig.summaryRenderValue === 'availableunits') {
                //             return filteredGroupSummary[0].group_availUnitsCount ? filteredGroupSummary[0].group_availUnitsCount : '0';
                //         } else if (vm.schedulerConfig.summaryRenderValue === 'occupancy') {
                //             return filteredGroupSummary[0].group_availUnitsPercent ? filteredGroupSummary[0].group_availUnitsPercent : '0';
                //         }                              
                //     },    
                renderer: ({ startDate, endDate, eventStore, resourceStore, events, resources, groupRecord, groupField, groupValue }) => {
                    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
                    const filteredGroupSummary = vm.schedulerConfig.response.groupSummaryResponse.find(date =>
                        // date.group_startDate === formattedStartDate && date.group_unitTypeName === groupValue

                        // changed to group_unitTypeId from unitTypeName
                        date.group_startDate === formattedStartDate && date.group_unitTypeId === groupValue
                    );
                    if (!filteredGroupSummary) {
                        return;
                    }
                    switch (vm.schedulerConfig.summaryRenderValue) {
                        case 'soldunits':
                            $(".btn-soldunits").addClass("btn-summary active");
                            return filteredGroupSummary.group_soldUnitsCount || '0';
                        case 'availableunits':
                            $(".btn-availableunits").addClass("btn-summary active");
                            return filteredGroupSummary.group_availUnitsCount || '0';
                        case 'occupancy':
                            $(".btn-occupancy").addClass("btn-summary active");
                            return filteredGroupSummary.group_availUnitsPercent || '0';
                        default:
                            return;
                    }
                },
            },
            timeSelection: {
                // selectOnClick    : false,
                // selectedTimeSpan: {
                //     startDate: new Date(2023, 12, 15),
                //     endDate: new Date(2023, 12, 19)
                // },
                // Uncomment to show a tooltip when hovering the time selection header element
                // tooltipTemplate({ timeRange }) {
                //     const count = this.client.getAvailableResources(timeRange.startDate, timeRange.endDate).length;

                //     return `${count || 'No'} available resource${count > 1 ? 's' : ''}`;
                // },
                tooltipTemplate() {
                    this.hoverTooltip.allowOver = true;
                    this.hoverTooltip.hideDelay = false;
                    this.hoverTooltip.autoHide = false;
                    this.hoverTooltip.autoClose = false;
                    //this.hoverTooltip.closable = true;
                    // this.hoverTooltip.cls = "bCustomTooltip";
                    const { timeRanges : [ timeRange ] } = this;
                    const startDate = moment(timeRange.startDate);
                    const endDate = moment(timeRange.endDate);
                    vm.filteredResources = this.client.getAvailableResources(timeRange.startDate, timeRange.endDate);
                    //to show all assigned and unassigned count in the tooltip
                    // var count = vm.filteredResources.length
                    
                    //to show only assigned count in the tooltip
                    var count = vm.filteredResources.filter((assigned) => assigned.IsAssigned === 1).length;
                    let stayCountVal = endDate.diff(startDate, 'days');
                    const stayCount = stayCountVal <= 1 ? '('+stayCountVal+' night)' : '('+stayCountVal+' nights)'
                    var listingText = count <= 1 ? 'Listing' : 'Listings'
                    // let stayCount = '('+(endDate.format('YYYY-MM-DD') - startDate.format('YYYY-MM-DD'))+' nights)';
                    // return `${count || 'No'} available resource${count > 1 ? 's' : ''}`;
                    const noUnits = (count == 0) ? 'unitNotAvailableTooltip' : ''
                    // getting min of min stay value
                    // const minStayValues = vm.availableUnitsList.filter(unit => unit.Unitactualinventory !== 1).map(item => item.MinofMinstay);
                                        
                    // commented below code, when rate plan changed we are getting infinity min nights in tooltip 
                    // const minStayValues = vm.resAvailbleList.map(item => item.MinofMinstay);
                    // console.log("minStayValues", minStayValues);
                    // let minOfMinStay = Math.min(...minStayValues);

                    // when rate plan changed we are getting infinity min nights in tooltip 
                    const minStayValues = vm.resAvailbleList.map(item => item.MinofMinstay);
                    // Filter out zero values
                    const nonZeroMinStayValues = minStayValues.filter(value => value !== 0);
                    // Check if there are non-zero values before finding the minimum
                    let minOfMinStay;
                    if (nonZeroMinStayValues.length > 0) {
                        minOfMinStay = Math.min(...nonZeroMinStayValues);
                    } else {
                        // Handle the case when all values are zero
                        minOfMinStay = 0; // You can assign a different default value if needed
                    }

                    if (count == 0) {
                        count = minOfMinStay
                        listingText = minOfMinStay == 0 ? 'Listings' : 'Nights Min'
                    }
                    this.hoverTooltip.cls = "bCustomTooltip" + " " +noUnits;
                    return `<div class="bCustomTooltipInfo">
                        <div class="dateRangeTooltipInfo">
                            <div class="dateRangeDates">
                                <div class="startEndDates">
                                    <span style="font-size: 14px;font-weight: 600;">${(startDate.format('MMM DD'))} - ${(endDate.format('MMM DD'))}</span> 
                                    <span style="font-size: 12px;">${(stayCount)}</span>
                                </div>   
                                <div class="noPersons">
                                    <button class="btn btn-default btn-sm btn-sm-icon" id="subtractPersonButtonID">
                                    <i aria-hidden="true" class="fa fa-minus"></i>
                                    </button>
                                    <div>
                                        <span style="font-size: 14px;font-weight: 600;" id="brynumberOfPersonsId">${vm.numberOfPersons}</span> 
                                        <span style="font-size: 12px;"> people</span>
                                    </div>
                                    <button class="btn btn-default btn-sm btn-sm-icon" id="addPersonButtonID">
                                    <i aria-hidden="true" class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="separator"></div>
                            <div class="dateRangeAvailability">
                                    <div class="startEndDates">
                                        <span style="font-size: 14px;font-weight: 600;" id="listingCount">${count}</span> 
                                        <span style="font-size: 12px;" id="listingText">${listingText}</span>
                                    </div>
                                    <div class="dateRangeActions">
                                        <button class="btn btn-lint btn-sm btn-sm-icon" id="filterClickID">
                                        <i aria-hidden="true" title="Filters" class="fa fa-filter" style="font-size: 13px;"></i>
                                        </button>
                                        <button class="btn btn-lint btn-sm btn-sm-icon" id="searchClickID">
                                        <i aria-hidden="true" title="Search" class="fa bSearch"></i>
                                        </button>
                                        <button class="btn btn-lint btn-sm btn-sm-icon" id="closeActionID">
                                        <i aria-hidden="true" title="Close" class="far fa-times" style="font-size: 16px;line-height: 9px;"></i>
                                        </button>
                                    </div>
                            </div>
                        </div>`; 
                    //${count || 'No'} available resource${count > 1 ? 's' : ''}`;
                },
                headerRenderer({ timeRange }) {
                    const startDate = moment(timeRange.startDate);
                    const endDate = moment(timeRange.endDate);
                    const duration = moment.duration(endDate.diff(startDate));
                    const daysDifference = duration.asDays();
                    if (daysDifference <= 1) {
                        // console.log('Length between dates: 1 day');
                        return `<span class='b-selection-start'>${moment(timeRange.startDate).format('DD')}</span>
                        <span>-</span>
                        <span class='b-selection-end'>${moment(timeRange.endDate).format('DD')}</span>
                        `;
                    } else {
                        // console.log(`Length between dates: ${daysDifference} days`);
                        return `<span class='b-selection-start'>${moment(timeRange.startDate).format('DD ddd')}</span>
                        <span class='b-selection-end'>${moment(timeRange.endDate).format('DD ddd')}</span>
                        `;
                    }
                        // <button class='b-fa b-fa-plus' data-btip='Create event'></button>
                        // <i class='b-icon b-icon-close' data-ref="closeButtonIcon"></i>
                        // <i class='b-icon b-icon-close' data-ref="closeButton"></i>
                }
            }
        },
        // bbar : [
        //     {
        //         ref  : 'selectionLabel',
        //         type : 'widget'
        //     }
        // ],
        // tbar : [
        //     {
        //         type      : 'slider',
        //         ref       : 'zoom',
        //         width     : 130,
        //         //text      : 'Zoom',
        //         //showValue : true,
        //         min       : 7,
        //         cls: "sliderBar000",
        //         max       : 10,
        //         value     : 10,
        //         onInput({ value }) {
        //             schedulerConfig.zoomLevel = value;
        //             isZoomChanged = true;
        //             // schedulerConfig.resourceTimeRanges.forEach(range => {
        //             //     //range.setVisible(false); // Set to true to show
        //             //     range.name = '';
        //             // });
        //         }
        //     },
        //     {
        //         type                 : 'textfield',
        //         // ref                  : 'filterByName',
        //         icon                 : 'b-fa b-fa-filter',
        //         placeholder          : 'Find tasks by name',
        //         clearable            : true,
        //         width                : '15em',
        //         keyStrokeChangeDelay : 100,
        //         triggers             : {
        //             filter : {
        //                 align : 'start',
        //                 cls   : 'b-fa b-fa-filter'
        //             }
        //         },
        //         onChange({ value }) {
        //             value = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        //             // Replace all previous filters and set a new filter
        //             schedulerConfig.eventStore.filter({
        //                 filters : event => event.name.match(new RegExp(value, 'i')),
        //                 replace : true
        //             });

        //             /*
        //                     // The code above is a one liner version of:

        //                     // Remove all previous filters
        //                     scheduler.eventStore.clearFilters();

        //                     // Set a new filter
        //                     scheduler.eventStore.filter(event => event.name.match(new RegExp(value, 'i')));

        //                     // Having `replace` provided makes the filter config go to the nested `filters` property,
        //                     // see more in the Store.filter docs
        //                 */
        //         }
        //     },
        //     {
        //     type                 : 'textfield',
        //     ref                  : 'highlight',
        //     placeholder          : 'Highlight tasks',
        //     clearable            : true,
        //     width                : '15em',
        //     keyStrokeChangeDelay : 100,
        //     triggers             : {
        //         filter : {
        //             align : 'start',
        //             cls   : 'b-fa b-fa-search'
        //         }
        //     },
        //     onChange({ value }) {
        //         scheduler.eventStore.forEach(task => {
        //             const taskClassList = new DomClassList(task.cls);

        //             if (value !== '' && task.name.toLowerCase().includes(value.toLowerCase())) {
        //                 taskClassList.add('b-match');
        //             }
        //             else {
        //                 taskClassList.remove('b-match');
        //             }

        //             task.cls = taskClassList.value;
        //         });

        //         scheduler.element.classList[value.length > 0 ? 'add' : 'remove']('b-highlighting');
        //     }
        // }
        // ],
        // onTimeSelectionElementClick({ domEvent, startDate, endDate }) {
        //     if (domEvent.target.matches('button')) {
        //         alert(domEvent.target.id);
        //     }
        // },
        columns: [
            {
                type: 'resourceCollapse',
                enableCellContextMenu: false, //disbaled right click menu for properties
                enableHeaderContextMenu: false, //disbaled right click menu for properties header
            },
            {
                type: 'resourceInfo', text: "Name", field: "PropertyandUnitNickName", width: 345,
                htmlEncode: false, readOnly: true,
                sum: 'count',
                summaryRenderer: data => {
                    return `<button type="button" id="btn-soldunits" class="btn-soldunits btn-summary"> Sold Units </button>
                            <button type="button" id="btn-availableunits" class="btn-availableunits"> Available Units </button>
                            <button type="button" id="btn-occupancy" class="btn-occupancy"> Occupancy % </button>`;
                },
                showEventCount: false,
                enableCellContextMenu: false, //disbaled right click menu for properties
                enableHeaderContextMenu: false, //disbaled right click menu for properties header
                // showMeta : data => {
                //     return '2345678';
                // },
                // showMeta : property => `ID ${property.UnitName}`
                // showMeta : property => `${property.UnitName}`,
                renderer({ value, record }) {
                    var unitClassName = record.data.UnitClassName == undefined ? '' : record.data.UnitClassName;
                    var unitClassColorCode = record.data.UnitClassName == undefined ? '' : 'UnitClass ' + record.data.colorcode;
                    var url = ""
                    // const dummyImageUrl = "https://buffer.com/library/content/images/size/w1200/2023/10/free-images.jpg"; 
                    // onerror="this.classList.add(\'' + dummyImageClass + '\')"
                    // onerror="this.src=\'' + dummyImageUrl + '\'"
                    const brokenImageClass = "dummyImage";

                    if (record.data.ImageUrl) {
                        url = imageUrls(record.data.ImageUrl);
                        imageClassName = "";
                    } else {
                        imageClassName = "dummyImage";
                    }
                    return '<img style="width: 60px;" draggable="false" loading="lazy" class="b-resource-img ' + imageClassName + '" alt="" src="' + url + '" onerror="this.classList.add(\'' + brokenImageClass + '\')" role="presentation" style="">' +
                        '<dl class="b-propertyandunitnickname" role="presentation"><dt role="presentation"><span>' + value + '</span><span class="nameOverflow ' + unitClassColorCode + '">' + unitClassName + '</span></dt><dd class="b-resource-meta b-unitName" role="presentation" style="font-size:11px;">' + record.data.UnitName + '</dd></dl>';
                    // return '<span class="propertyandunitname">'+value+'</span><span class="propertyandunitname '+record.data.UnitClassName.replaceAll(/\s/g,'')+'">'+record.data.UnitClassName+'</span>'
                },
            },
            // { text : "Unit Nickname", field : "UnitNickName", width : 130},
            // { text : "Unit Class", field : "UnitClassName", width : 180, htmlEncode : false,
            //     renderer$({ value }) {
            //         var class1 = '';
            //         if (value === '3BR Standard') {
            //             class1 = "3BRS";
            //         } else if (value === '4BR Premium') {
            //             class1 = "4BRP";
            //         }
            //         return '<span class='+class1+'>'+value+'</span>';
            //     }
            // }
        ],
        resources: response.bryntumResponse.resources,
        events: response.bryntumResponse.events,
        resourceTimeRanges: response.bryntumResponse.resourceTimeRanges,

        // date constraint
        // getDateConstraints() {
        //     const today = new Date(); // Get the current date and time
        //     const yesterday = new Date(today);
        //     yesterday.setHours(0, 0, 0, 0);
        //     // yesterday.setDate(today.getDate() - 1); // Subtract one day

        //     return {
        //         // start : new Date(2023, 8, 13),
        //         // end   : new Date(2023, 8, 20)
        //         start : yesterday
        //     };
        // },

        // Add when event is changed
        eventRenderer(eventRecord) {
            // console.log('Event changed:', eventRecord);
            // console.log("eventRecord.eventRecord.originalData.name =======>",eventRecord.eventRecord.originalData.name)
            // return `${eventRecord.eventRecord.originalData.name}`
            //eventRecord.resourceRecord.timeRanges
            // let unassignedResCount = eventRecord.resourceRecord.timeRanges.filter(item => item.originalData.unassignedResCount != "");
            // if (unassignedResCount.length > 0) {
            //      eventRecord.eventRecord.style = 'top:100px';
            //     //  eventRecord.eventRecord.style = 'bottom:50px';
            //     //const top = Math.min(100, 50); // Ensure the event is fully visible
            //     //eventRecord.eventRecord.style = `top:${top}px`;
            // }
            var eventNameStr = ''
            
            if (eventRecord.eventRecord.data.cls.includes('availableUnitPriceOverlay')) {
                // eventRecord.eventRecord.style = 'z-index: 14';
                eventNameStr = `<div class="">
                    <div class="availableUnitOverlayName">
                        <span class="totalAmount">${eventRecord.eventRecord.originalData.name}</span>
                        <span class="otherAmount">${eventRecord.eventRecord.originalData.otherName}</span>
                    </div>
                </div>`
            } else {
                var hasCompanyName = eventRecord.eventRecord.originalData.CompanyName;
                var isAssigedRow = eventRecord.eventRecord.originalData.IsAssigned ? true : false
                var eventNameStr = `
                <div class="">
                    <div class="eventName">${eventRecord.eventRecord.originalData.name}${hasCompanyName !== null && isAssigedRow ? ` (${hasCompanyName})` : ''} </div>
                </div>`;
                // <!-- for RTB and alterations -->
                // var eventNameStr = `<div class="">
                // <div class="eventName">${eventRecord.eventRecord.originalData.name}${hasCompanyName !== null && isAssigedRow ? ` (${hasCompanyName})` : ''} <div class="${eventRecord.eventRecord.originalData.IsAltered ? "alteration" : ""}></div></div>
                //     </div>`;
                // <!-- for RTB and alterations -->
           
            }
            return eventNameStr;
        },
        resourceStore : {
            // modelClass : PropertyModel,
            listeners : {
                update(props) {
                    const { changes, record } = props;
                    if (changes?.eventLayout?.value === 'stack') {
                        
                        record.resourceMargin = {
                            // start : 60,
                            // end : 60
                            // start: vm.clientType[0].IsHostMode ? 45 : 60,
                            // end: vm.clientType[0].IsHostMode ? 1 : 1
                            //setting gap for each reservations based on assigned and unassigned row expanded
                            start: vm.clientType[0].IsHostMode == 1 ? 45 : (record.IsAssigned === 0 ? 60 : 45),
                            end: vm.clientType[0].IsHostMode == 1? 1 : (record.IsAssigned === 0 ? 1 : 1),

                        };
                        // record.resourceMargin = 60
                        record.timeRanges.forEach(record => record.cls = 'row-expanded');
                    } else if (changes.eventLayout && changes.eventLayout.value !== 'stack') {
                        record.resourceMargin = 0
                        record.timeRanges.forEach(record => record.cls = '');
                    }
                }
            }
        },
        listeners: {
            //scroll(event) {
            // This callback is triggered when the user starts scrolling
            //console.log('User started scrolling');
            // You can perform additional actions here
            //},
            // single click
            // timeRangeHeaderClick(event) {
            //     console.log("Time range header click",event)
            //     let startDate = moment(vm.selectedStartDate);
            //     let endDate = moment(vm.selectedEndDate);
            //     vm.filteredResources = vm.schedulerConfig.getAvailableResources(vm.selectedStartDate, vm.selectedEndDate);
            //     console.log("Filtered Resources",vm.filteredResources)
            //     const count = vm.filteredResources.length
            //     let stayCount = '(' + endDate.diff(startDate, 'days') + ' nights)';
            //     // let stayCount = '('+(endDate.format('YYYY-MM-DD') - startDate.format('YYYY-MM-DD'))+' nights)';

            //     const popup = new Popup({
            //         header      : 'Date Range Selection Popup',
            //         autoShow    : true,
            //         centered    : true,
            //         closeAction : 'destroy',
            //         closable    : true,
            //         width       : '30em',
            //         // html : `<h3 style="margin-top:0.5em">Bacon ipsum dolor </h3>
            //         //         <p style="line-height:1.5em">amet flank ribeye ham hock</p>`
            //         html : `<div>
            //         <span>${(startDate.format('MMM DD'))} - ${(endDate.format('MMM DD'))} ${(stayCount)}</span>
            //         <br><span>${count} Listing available</span>
            //         <div>
            //         <button class="btn btn-default btn-sm btn-sm-icon" id="minusButton">
            //         <i aria-hidden="true" class="fa fa-minus-circle" style="font-size: 14px;"></i>
            //         </button>
            //         <span>${vm.numberOfPersons} people</span>
            //         <button class="btn btn-default btn-sm btn-sm-icon" id="plusButton">
            //         <i aria-hidden="true" class="fa fa-plus-circle" style="font-size: 14px;"></i>
            //         </button>
            //         </div>
            //         <button class="btn btn-default btn-sm btn-sm-icon" id="filterClickID">
            //         <i aria-hidden="true" title="Filters" class="fa fa-filter" style="font-size: 14px;"></i>
            //         </button>
            //         <button class="btn btn-default btn-sm btn-sm-icon" id="searchClickID">
            //         <i aria-hidden="true" title="Search" class="fa fa-search" style="font-size: 14px;"></i>
            //         </button>
            //         <button class="btn btn-default btn-sm btn-sm-icon" id="closePopupActionID">
            //         <i aria-hidden="true" title="Close" class="fa fa-times-circle" style="font-size: 14px;"></i>
            //         </button>
            //         </div>`
            //     });
            //     // Get references to the buttons
            //     const minusButton = popup.element.querySelector('#minusButton');
            //     const plusButton = popup.element.querySelector('#plusButton');

            //     // Add click event listeners to the buttons
            //     minusButton.addEventListener('click', () => addPersonAction('minus', event));
            //     plusButton.addEventListener('click', () => addPersonAction('plus', event));

            //     vm.popup = popup;
            //     popup.show();
            // },
            
            beforeDragCreate({ date, source, eventRecord, resourceRecord, eventElement}) {
                resourceRecord.data.cls =  "createNewReservation";
                return date >= Date.now();
            },
            timeSelectionChange(event) {
                console.log("Time selection change click", event)
                // remove the events that are created by time selection feature
                let eventsToRemove = [];
                this.eventStore.forEach(event => {
                    if(event.data.cls == "availableUnitPriceOverlay") {
                        eventsToRemove.push(event);
                    } 
                });
                this.eventStore.remove(eventsToRemove);
                // call to get available units
                vm.selectedStartDate = event.startDate;
                vm.selectedEndDate = event.endDate;
                vm.searchByUnits = vm.clientType[0].IsHostMode == 1 ? false : true;
                vm.getAvailableUnitList();
                vm.numberOfPersons = 2;
                $(".b-theme-stockholm")[0].innerHTML = ""
            },
            // timeSelectionElementClick({ source, domEvent, startDate, endDate }) {
            //     console.log("Time selection element click", source)
            //     if (domEvent.target.matches('[data-ref="closeButtonIcon"]')) {
            //         let eventsToRemove = [];
            //         this.eventStore.forEach(event => {
            //             console.log(event)
            //             if(event.data.cls == "availableUnitPriceOverlay") {
            //                 eventsToRemove.push(event);
            //             } 
            //         });
            //         // remove selected timespan
            //         this.features.timeSelection.selectedTimeSpan = null;
            //         // remove the events that are created by time selection feature
            //         this.eventStore.remove(eventsToRemove);
            //     }
            //     if (domEvent.target.matches('button')) {
            //         let searchAvailableUnitList = vm.availableUnitsList;
            //         let addEventsOverlay = searchAvailableUnitList
            //         .filter(unit => unit.Unitactualinventory === 1)
            //         .map(unit => {
            //             return {
            //                 name : '' + unit.FromTotalValue + '',
            //                 resourceId : unit.UnitId,
            //                 //iconCls : 'b-fa b-fa-star',
            //                 cls : 'availableUnitPriceOverlay',
            //                 eventColor : 'gray',
            //                 eventStyle : 'border',
            //                 resizable : false,
            //                 startDate,
            //                 endDate
            //             };
            //         });
            //         this.eventStore.add(addEventsOverlay);
            //     }
            // },
            resourceTimeRangeClick({ resourceTimeRangeRecord, resourceRecord }) {
                // alert(resourceTimeRangeRecord);
                // This event handler is called when a resource time range is clicked
                console.log("RTRC - resourceTimeRangeRecord --> ", resourceTimeRangeRecord)
                console.log("RTRC - resourceRecord --> ", resourceRecord)

                // if (resourceTimeRangeRecord.data.unassignedResCount != "") {
                //     // Modify the event layout value of the clicked resource
                //     resourceRecord.data.eventLayout = 'stack';
                //     vm.showUnassignedRes(resourceRecord,'unassignedCount');
                //     // If you want to update the event rendering immediately, call the `refresh` method
                //     schedulerConfig.refresh();
                // }

                if ($(".b-selected").length > 0) {
                    $(".b-selected").attr("aria-selected", "false");
                    $(".b-selected").removeClass("b-selected");
                }
            },
            horizontalScroll() {
                // Keep scrollTo date synced with the visible date
                if (this.widgetMap) {
                    // console.log("Horizontal Scroll", this.viewportCenterDate)
                    //On scroll horizontally the month name and year is not updating correctly in the above date picker component
                    vm.visibleMonthYear = moment(this.viewportCenterDate).format("MMMM YYYY")
                }
            },
            buffer: 100,
            handlerAddNewButton() {
                console.log("Button")
            },
            eventClick(eventRecord) {
                // $(".b-selected").attr("aria-selected", "false");
                // $(".b-selected").removeClass("b-selected");
                console.log("event Click Action")
                // let reservationId = eventRecord.eventRecord.data.UnitClassId != -1 ? eventRecord.eventRecord.data.Reservationid : eventRecord.eventRecord.data.reservationId
                var data = {
                    "EndDate": moment(eventRecord.eventRecord.data.endDate).format("YYYY-MM-DD"),
                    "PropertyId": eventRecord.eventRecord.data.PropertyId,
                    "RatePlanId": eventRecord.eventRecord.data.RatePlanId,
                    "ReservationId": eventRecord.eventRecord.data.Reservationid,
                    "StartDate": moment(eventRecord.eventRecord.data.startDate).format("YYYY-MM-DD"),
                    "UnitClassId": eventRecord.eventRecord.data.UnitClassId,
                    "UnitId": eventRecord.eventRecord.data.resourceId,
                };
                if (eventRecord.eventRecord.data.cls.includes('availableUnitPriceOverlay')) {
                    if(vm.selectedStartDate && vm.selectedEndDate){
                        let RatePlanId = vm.ratePlanList.filter(
                            obj => obj.id == vm.myValue
                        );
                        vm.currResObj = {}
                        vm.currentUnitObj = {
                            ...eventRecord.event.resourceRecord.data,
                            startDate: moment(vm.selectedStartDate).format("YYYY-MM-DD"),
                            endDate: moment(vm.selectedEndDate).format("YYYY-MM-DD"),
                            Adults: null,
                            Children: null,
                            Persons: vm.numberOfPersons,
                            RatePlanId: RatePlanId ? RatePlanId[0].RatePlanId : null,
                            RatePlanName : RatePlanId ? RatePlanId[0].RatePlanName : null,
                            selectedRatePlan : RatePlanId
                        }
                    }
                } else {
                    vm.navigateToReservation(data);
                }
            },
            cellClick(event) {
                //Resource cell click - You can now access the clicked resource and its properties
                const clickedResource = event.record;
                console.log('Clicked resource:event', event, 'Clicked resource.event.record:', clickedResource)
                const timeRanges = event.record.timeRanges
                const columnType = event.column.type;
                if (columnType == 'resourceCollapse') {
                    let unassignedResCount = timeRanges.filter(item => item.originalData.unassignedResCount != "");
                    isUnassignedResCountAvailable = unassignedResCount.length;
                    if (unassignedResCount.length > 0) {
                        if (!event.record.data.IsAssigned && event.record.originalData.eventLayout == 'none') {
                            // Modify the event layout value of the clicked resource
                            event.record.originalData.eventLayout = 'stack';
                            // vm.showUnassignedRes(event.record, 'unassignedCount');
                            event.record.rowHeight = 80 + unassignedResCount.length
                            vm.showUnassignedRes(event.record,'unassignedCount',null,null)
                        } else if (!event.record.data.IsAssigned && event.record.originalData.eventLayout == 'stack') {
                            event.record.originalData.eventLayout = 'none';
                            vm.removeEvents(event.record);
                            //event.record.rowHeight = 50;
                        }
                        // If you want to update the event rendering immediately, call the `refresh` method
                        vm.schedulerConfig.refresh();
                    }else if(unassignedResCount.length <= 0 && event.record.originalData.eventLayout == 'none'){
                        event.record.rowHeight = 75;
                        event.record.originalData.eventLayout = 'stack';
                    }else if(unassignedResCount.length <= 0 && event.record.originalData.eventLayout == 'stack'){
                        event.record.rowHeight = 55;
                        event.record.originalData.eventLayout = 'none';
                    }
                } else if (columnType == 'resourceInfo') {
                    console.log(" resoure info click")
                    if (event.cellSelector.id && typeof event.cellSelector.id === 'string' && event.cellSelector.id.includes('group-header')) {
                        console.log('cell selector id', event.cellSelector.id)
                        return;
                    }
                    // if (event.record.data.IsAssigned != 0 && event.record.data.UnitClassId != -1) {
                        vm.openUnitSummaryPanel = true;
                        let RatePlanId = vm.ratePlanList.filter(
                            obj => obj.id == vm.myValue
                        );
                        // if(vm.selectedStartDate && vm.selectedEndDate){
                            // vm.currResObj = {}
                            vm.unitSummaryObj = {
                                ...event.record.data,
                                startDate: vm.selectedStartDate ? moment(vm.selectedStartDate).format("YYYY-MM-DD") : null,
                                endDate: vm.selectedEndDate ? moment(vm.selectedEndDate).format("YYYY-MM-DD") : null,
                                Adults: null,
                                Children: null,
                                Persons: vm.numberOfPersons,
                                RatePlanId: RatePlanId ? RatePlanId[0].RatePlanId : null,
                                RatePlanName : RatePlanId ? RatePlanId[0].RatePlanName : null,
                                selectedRatePlan : RatePlanId
                            }
                        // }
                    // } 
                }
            },
            // event double click
            eventDblClick() {
                console.log("eventDblClick called !!");
            },
            eventContextMenu() {
                console.log("right click event")
            },
        },

        getAvailableResources(startDate, endDate) {
            let searchAvailableUnitList = vm.availableUnitsList.concat(vm.unassignAvailUnits);
            vm.resAvailbleList = []
            var resMinStayList = this.resourceStore.query(resource => searchAvailableUnitList.some(unit => {
                if(resource.id == unit.UnitId){
                    vm.resAvailbleList.push(unit);
                    return unit;
                }
            }));
            let availableAssignedUnitsList = vm.availableUnitsList.filter(unit => unit.Unitactualinventory === 1)
            .map(unit => {
                 return unit
            })
            let availableUnassignedUnitsList = vm.unassignAvailUnits.filter(unit => unit.Unitactualinventory === 1)
            .map(unit => {
                 let avalUnitId = unit.UnitId
                     let uVal = vm.schedulerConfig.resourceStore.data.filter(unitData => unitData.IsAssigned == 0 && unitData.UnitTypeId == unit.UnitId)
                    //  console.log('uVal', uVal);
                     if(uVal.length){
                         avalUnitId = uVal[0].UnitId
                        //  console.log('avalUnitId', avalUnitId);
                         return uVal[0]
                     }
            })
            let combinedArray = availableAssignedUnitsList.concat(availableUnassignedUnitsList);
            let res = this.resourceStore.query(resource => combinedArray.some(searchUnit => (searchUnit.UnitId == resource.UnitId && searchUnit.UnitTypeId == resource.UnitTypeId)));
            return res;
        },

        // onTimeSelectionChange({ startDate, endDate }) {
        //     const availableResources = startDate ? this.getAvailableResources(startDate, endDate).length : this.resourceStore.count;
        //     this.widgetMap.selectionLabel.html = `${availableResources} resources available`;
        // }
    });

    // schedulerConfig.on('beforePresetChange', ({ to }) => {
    //     to.options.startDate = new Date('2023-10-4');
    //     to.options.endDate = new Date('2019-03-24');
    // });

    // schedulerConfig.on('presetChange', () => {
    //     schedulerConfig.timeAxis.reconfigure({
    //         startDate: new Date('2023-10-4')
    //     })
    // });

    // schedulerConfig.timeAxis.on('beforeReconfigure', function(event){
    //     console.log('before reconfig event',event)
    // if (arguments[0].config.endDate.setHours(0,0,0,0) >= new Date("2024-2-15").setHours(0,0,0,0)) {
    //     console.log("qwerty",arguments[0], new Date("2023-10-15"))
    //     console.log("scheduler infinite before configure endDate", arguments[0].config.endDate)
    //     console.log("scheduler infinite before configure startDate", arguments[0].config.startDate)
    //     return false;
    // }
    //     return true;
    // });

    // schedulerConfig.timeAxis.on('reconfigure', function(event){
    //     console.log('reconfig event',event)
    // });

    // schedulerConfig.timeAxis.on('change', function(event){
    //     console.log('chnage event',event)
    // });
    // opening unit detail panel on eventDragCreate
    schedulerConfig.on('afterDragCreate', ({ source, eventRecord, resourceRecord, eventElement }) => { 
        vm.getSelectedRangePrice(resourceRecord,eventRecord)
        let RatePlanId = vm.ratePlanList.filter(
            obj => obj.id == vm.myValue
        );
        vm.currResObj = {}
        vm.currentUnitObj = {
            ...resourceRecord.data,
            startDate:  moment(eventRecord.data.startDate).format("YYYY-MM-DD"),
            endDate: moment(eventRecord.data.endDate).format("YYYY-MM-DD"),
            Adults: null,
            Children: null,
            Persons: 2,
            RatePlanId: RatePlanId ? RatePlanId[0].RatePlanId : null,
            RatePlanName : RatePlanId ? RatePlanId[0].RatePlanName : null,
            selectedRatePlan : RatePlanId,
        }
    });
    // adding css class name on beforeEventEdit and after drag
    schedulerConfig.on('beforeEventEdit', ({ eventRecord, resourceRecord }) => {        
        resourceRecord.data.cls =  "createNewReservation";
    })

    schedulerConfig.on({
        scroll() {
            // Vertical Scroll
            const maxY = schedulerConfig.scrollable.maxY;
            const currentY = schedulerConfig.scrollable.y;
            vm.infiniteScrollDirection = '';
            console.log(`Current Y: ${currentY}, Max Y: ${maxY}`);
            if (currentY === maxY) {
                console.log('Reached end Vertical');
                // Disabling verticalInfiniteScroll because, at the bottom of the screen, when any units are expanded, it automatically closes due to the combination of the getBryntumSchedulerTapeChartData call and verticalInfiniteScroll being set to true.                
                // vm.verticalInfiniteScroll = true;
                // vm.pageNo++;
                // vm.isFilteredApplied === false ? vm.getBryntumSchedulerTapeChartData() : '' ;
                // vm.getBryntumSchedulerTapeChartData();
            }
        }
    });

    schedulerConfig.eventStore.on({
        loadDateRange(e) {
            if (e.changed) {
                var initialStartDate = vm.initialStartDate;
                var initialEndDate = vm.initialEndDate;
                vm.dateRequestType = '';
                vm.latestResponseDirection = 'past';
                if (new Date(e.new.startDate).setHours(0, 0, 0, 0) > new Date(e.old.startDate).setHours(0, 0, 0, 0)) {
                    // console.log("qwerty:  ------ right");
                    vm.scrollStartDate = moment(initialEndDate).format("YYYY-MM-DD"); //vm.infiniteScrollDirection === 'left' ? moment(initialEndDate).format("YYYY-MM-DD") : moment(vm.schedulerEndDate).format("YYYY-MM-DD");
                    vm.scrollEndDate = moment(vm.scrollStartDate).add(45, 'days').format("YYYY-MM-DD");
                    vm.infiniteScrollDirection = 'right';
                    // Handling unassinged row dates
                    vm.unassignScrollStartDate = moment(vm.unassign_InitialEndDate).format("YYYY-MM-DD");
                    vm.unassignScrollEndDate = moment(vm.unassignScrollStartDate).add(60, 'days').format("YYYY-MM-DD");
                } else {
                    // console.log("qwerty:  ------ left");
                    vm.scrollEndDate = moment(initialStartDate).format("YYYY-MM-DD"); //vm.infiniteScrollDirection === 'right' ? moment(initialStartDate).format("YYYY-MM-DD") : moment(vm.schedulerStartDate).format("YYYY-MM-DD");
                    vm.scrollStartDate = moment(vm.scrollEndDate).subtract(45, 'days').format("YYYY-MM-DD");
                    vm.infiniteScrollDirection = 'left';
                    // Handling unassinged row dates
                    vm.unassignScrollEndDate = moment(vm.unassign_InitialStartDate).format("YYYY-MM-DD");
                    vm.unassignScrollStartDate = moment(vm.unassignScrollEndDate).subtract(60,'days').format("YYYY-MM-DD");
                }
                vm.filterObj.startDate = moment(vm.schedulerConfig.visibleDateRange.startDate).format("DD MMM YYYY");
                vm.betaStartDate = moment(vm.filterObj.startDate).format("MMMM YYYY")
                // vm.filterObj.endDate = moment(vm.schedulerConfig.visibleDateRange.endDate).format("DD MMM YYYY");
                // vm.filterObj.endDate = moment(vm.schedulerConfig.visibleDateRange.startDate).add(90, "days").format("DD MMM YYYY");
                vm.getBryntumSchedulerTapeChartData();
                //  hotel mode and if only unassinged row clicked
                if (vm.clientType[0].IsHostMode != 1 && isUnassignedResCountAvailable > 0) {
                    vm.showUnassignedRes(null,'unassignedCount',vm.unassignScrollStartDate,vm.unassignScrollEndDate)
                }
                console.log("scheduler date change start date", e.new.startDate, vm.schedulerConfig.visibleDateRange.startDate);
                console.log("scheduler date change end date", e.new.endDate, vm.schedulerConfig.visibleDateRange.endDate)
                // vm.$store.dispatch("toastr", {
                //     type: "success",
                //     header: "BryntumCalendar",
                //     message: "Need "+moment(visibleDateRange.startDate).format("YYYY-MM-DD")+" to "+ moment(visibleDateRange.endDate).format("YYYY-MM-DD")
                // });
                //Toast.show(`Need ${DH.format(e.new.startDate, 'DD-MMM-YYYY')} to ${DH.format(e.new.endDate, 'DD-MMM-YYYY')}`);
            }
        }
    });

    schedulerConfig.overlappingEventSorter = function (a, b) {
        // Always sort b-fa-mouse-pointer on the bottom
        if (event && event.target.classList.contains("b-flip")) {
            if (a._cls.assigned && b._cls.unassigned) {
                return -1
            } else if (b._cls.assigned && a._cls.unassigned) {
                return 1;
            }
        } else {
            if (a._cls.assigned && b._cls.unassigned) {
                return 1
            } else if (b._cls.assigned && a._cls.unassigned) {
                return -1;
            }
        }
    }
    // Add an event listener to handle custom button clicks
    const schedulerContainer = schedulerConfig.element;
    schedulerContainer.addEventListener('click', event => {
        console.log("element")
        // code for Alterations and RTB
        // if (event.target.classList.contains('alteration')) {
        //     console.log("Icon clicked",event.eventRecord.originalData.EXTERNALCONFIRMATIONNUMBER);
        //     const confirmationNumber=event.eventRecord.originalData.EXTERNALCONFIRMATIONNUMBER
        //     let isDoubleClick = false
        //     schedulerConfig.eventStore.forEach(event => {
        //         const taskClassList = new DomClassList(event.cls);
        //         if(event.data.EXTERNALCONFIRMATIONNUMBER == confirmationNumber){
        //             taskClassList.toggle('b-match');
        //             if (!taskClassList["b-match"]){
        //                 isDoubleClick=true
        //             }
        //         }
        //         else{
        //             taskClassList.remove('b-match');
        //         }
        //         event.cls=taskClassList.value

        //     })

        //     if(isDoubleClick) {
        //         schedulerConfig.element.classList['remove']('b-highlighting')   
        //     }
        //     else{
        //         schedulerConfig.element.classList['add']('b-highlighting')
        //     }

        // }
        // code for Alterations and RTB
    });

    if(vm.clientType[0].IsHostMode == 1){
        var summaryBtns = document.getElementsByClassName("b-grid-summary-value")[0];
    }else{
        var elements = document.getElementsByClassName("b-grid-summary-value");
        var lastElement =  elements.length - 1;
        var summaryBtns = document.getElementsByClassName("b-grid-summary-value")[lastElement];
    }
    summaryBtns.addEventListener('click', event => {
        if (event.target.classList.contains('btn-soldunits')) {
            vm.schedulerConfig.summaryRenderValue = "soldunits";
        } else if (event.target.classList.contains('btn-availableunits')) {
            vm.schedulerConfig.summaryRenderValue = "availableunits";
        } else if (event.target.classList.contains('btn-occupancy')) {
            vm.schedulerConfig.summaryRenderValue = "occupancy";
        }
        refreshSummary();
    });

    function refreshSummary() {
        schedulerConfig.features.summary.refresh();
        schedulerConfig.features.groupSummary.refresh();
        var evt = event;
        setTimeout(function () {
            $(".btn-summary").removeClass("active");
            $(evt.target).addClass("btn-summary active");
        }, 500)
    }

    function imageUrls(imgGuid) {
        // if(imgGuid == undefined) {
        //     imageClassName = "dummyImageBig";
        // }
        let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
        if (isBase64) {
            return imgGuid;
        }
        return apiUrl + "/downloadImage/" + imgGuid + "/430x300";
    }

    // function addPersonAction(action, event) {
    //     console.log("add person action", action)
    //     vm.numberOfPersons = (action == 'minus') ? (vm.numberOfPersons - 1) : (vm.numberOfPersons + 1);
    //     vm.schedulerConfig.listeners.timerangeheaderclick[0].fn(event)
    // }

    // Add eventTooltip
    // schedulerConfig.features.eventTooltip = {
    //     template: data => {
    //         const startDate = data.startDate;
    //         const endDate = data.endDate;
    //         const lengthInDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
    //         console.log("eventTooltip data ====> ", data)
    //         return `<h4>Check-in:</h4>Start: ${startDate}<h4>Length of stay:</h4>${lengthInDays} nights`;
    //     }
    // };

    // function isWeekend(date) {
    //     const dayOfWeek = date.getDay();
    //     return dayOfWeek === 0 || dayOfWeek === 6; // Sunday is 0, Saturday is 6
    // }
    // schedulerConfig.render();
    return schedulerConfig;
}